// extracted by css-extract-rspack-plugin
export default {"container":"CopilotReviewSummary-module__container__MNZ5f","title":"CopilotReviewSummary-module__title__oKfzN"};